import { TrackToggleProps, useTrackToggle } from '@livekit/components-react'
import React from 'react'
import BaseButton from './BaseButton'
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined'
import MicOffOutlinedIcon from '@mui/icons-material/MicOffOutlined'
import type { ToggleSource } from '@livekit/components-core'

const TrackToggle: <T extends ToggleSource>(
  props: TrackToggleProps<T> & React.RefAttributes<HTMLButtonElement>
) => React.ReactNode = /* @__PURE__ */ React.forwardRef(function TrackToggle<
  T extends ToggleSource
>({ showIcon, ...props }: TrackToggleProps<T>, ref: React.ForwardedRef<HTMLButtonElement>) {
  const { buttonProps, enabled } = useTrackToggle(props)
  return (
    <BaseButton ref={ref} {...buttonProps} disabled={false} className="control-button-padding-left">
      {enabled && (showIcon ?? true) ? (
        <MicNoneOutlinedIcon className="mic-icon-active" />
      ) : (
        <MicOffOutlinedIcon className="mic-icon-active" />
      )}
      {props.children}
    </BaseButton>
  )
})

export default TrackToggle
